import {Component, EventEmitter, Inject, isDevMode, OnDestroy, OnInit, Output} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import {FullChild} from "../../../../interfaces/FullChild";
import {ChildService} from "../../../../components/child/child.service";
import {QuestionsService} from "../../../questions/questions.service";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {QuestionModel} from "../../../../interfaces/QuestionModel";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {ActivatedRoute} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import firebase from 'firebase/compat/app'
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import {LogService} from "../../../../services/log.service";
@Component({
  selector: 'app-follow-up-question',
  templateUrl: './follow-up-question.component.html',
  styleUrls: ['./follow-up-question.component.scss']
})
export class FollowUpQuestionComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  answers = ['Yes', 'No', 'Sometimes']
  // selectedCentre=''
  maxDate = new Date()
  // selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
disableSubmit=false
  _centres$:Observable<Centre[]>
  @Output() selectionChange = new EventEmitter<any>();

  selectedCentre: Centre | null = null;



  childBycentre!: Observable<FullChild[]>;
  selectedChildCode: any;
  filteredChildren: FullChild[] | undefined;
  questionList!: any[];
  selectedAnswers: any;
  questionArray: any[] = [];
  answersObject: any;
  form!: FormGroup<any>
  id?:string | null
  userdata: any
editMode=false


  childSelectControl = new FormControl(null, Validators.required);
  childSearchControl = new FormControl('');
  filteredChildData: FullChild[] = [];
  childData: FullChild[] = [];

  assessmentTypes=[ "Follow Up Assessment 1", " Follow Up Assessement 2", "Follow Up Assessment 3", "Follow Up Assessment 4", "Follow Up Assessment 5", "Follow Up Assessment 6","Follow Up Assessment 7","Follow Up Assessment 8","Follow Up Assessment 9","Follow Up Assessment 10"];

  // constructor(private readonly centreService:CentreService,
  //             private childService: ChildService,
  //             private mService: QuestionsService,
  //             private fb: FormBuilder,
  //             private  router:ActivatedRoute,
  //             protected mDialogRef:MatDialogRef<FollowUpQuestionComponent>,
  //             private mFirestore: AngularFirestore,
  //             private readonly mDailogRef:MatDialogRef<FollowUpQuestionComponent>,
  //             private readonly mSnackbar:MatSnackBar,
  //             private mLogService : LogService,
  //             @Inject(MAT_DIALOG_DATA) public data: any,
  // )
  // {
  //   this.userdata=JSON.parse( localStorage.getItem('userData')!)
  //   this._centres$ = this.centreService.getAllCentres()
  //   this.router.paramMap.subscribe(res=>{
  //     this.id = res.get('id')
  //
  //     this.form =this.fb.group({
  //       centreCode: new FormControl(null, Validators.required),
  //       centreName: new FormControl(null, Validators.required),
  //       childName: new FormControl(null, Validators.required),
  //       childCode: new FormControl(null, Validators.required),
  //       sessionType:new FormControl('Followup Assessment'),
  //       submittedBy:new FormControl(this.userdata.userName,Validators.required),
  //       date:new FormControl(new Date()),
  //       dateOfAssessment:new FormControl(null,Validators.required),
  //       questions: new FormArray([],),
  //     })
  //
  //     this.mService.getCounsellingQuestionList().subscribe(res => {
  //       this.questionList = res
  //       console.log(this.questionList)
  //       if(this.id ==null)      this.setupQuestions(this.questionList)
  //
  //     })
  //
  //     this.id = this.data.id
  //
  //     if(this.id!=null) {
  //       this.editMode=true
  //       // alert(this.id)
  //       this.mFirestore.collection(this.env.counsellingFollowUp).doc(this.id!!).get().subscribe(res=>{
  //         let data =res.data() as any
  //         this.form.get('centreName')?.setValue(data?.centreName)
  //         this.form.get('centreCode')?.setValue(data?.centreCode)
  //         this.form.get('sessionType')?.setValue(data?.sessionType)
  //         this.form.get('childName')?.setValue(data?.childName)
  //         this.form.get('childCode')?.setValue(data?.childCode)
  //         this.form.get('dateOfAssessment')?.setValue(data?.dateOfAssessment.toDate())
  //         this.form.get('date')?.setValue(data?.date.toDate())
  //         // this.form.get('questions')?.setValue(data?.questions)
  //         let array=   this.form.get('questions')as FormArray
  //
  //         data?.questions.forEach((q:any)=>{
  //           // console.log(q)
  //           array.push(new FormGroup({
  //             question:new FormControl(q.question),
  //             ans:new FormControl(q.ans,Validators.required),
  //             remark:new FormControl(q.remark||'',Validators.required)
  //           }))
  //         })
  //       })
  //     }
  //   })
  // }

  constructor(
    private readonly centreService: CentreService,
    private childService: ChildService,
    private mService: QuestionsService,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    protected mDialogRef: MatDialogRef<FollowUpQuestionComponent>,
    private mFirestore: AngularFirestore,
    private readonly mDailogRef: MatDialogRef<FollowUpQuestionComponent>,
    private readonly mSnackbar: MatSnackBar,
    private mLogService: LogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.userdata = JSON.parse(localStorage.getItem('userData')!);
    this._centres$ = this.centreService.getAllCentres();

    this.router.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.id = res.get('id');

      this.form = this.fb.group({
        centreCode: new FormControl(null, Validators.required),
        centreName: new FormControl(null, Validators.required),
        childName: new FormControl(null, Validators.required),
        childCode: new FormControl(null, Validators.required),
        sessionType: new FormControl('Followup Assessment'),
        submittedBy: new FormControl(this.userdata.userName, Validators.required),
        date: new FormControl(new Date()),
        dateOfAssessment: new FormControl(null, Validators.required),
        questions: new FormArray([]),
      });

      this.mService.getCounsellingQuestionList().pipe(takeUntil(this._destroyed$)).subscribe(res => {
        this.questionList = res;
        console.log(this.questionList);
        if (this.id == null) this.setupQuestions(this.questionList);
      });

      // Get ID from MAT_DIALOG_DATA
      this.id = this.data.id;

      // *** EDIT MODE LOGIC - MOVE IT HERE FROM Submit() ***
      if (this.id != null) {
        this.editMode = true;

        this.mFirestore.collection(this.env.counsellingFollowUp)
          .doc(this.id!!)
          .get()
          .pipe(takeUntil(this._destroyed$))
          .subscribe(res => {
            let data = res.data() as any;

            // Set form values
            this.form.get('centreName')?.setValue(data?.centreName);
            this.form.get('centreCode')?.setValue(data?.centreCode);
            this.form.get('sessionType')?.setValue(data?.sessionType);
            this.form.get('childName')?.setValue(data?.childName);
            this.form.get('childCode')?.setValue(data?.childCode);
            this.form.get('dateOfAssessment')?.setValue(data?.dateOfAssessment.toDate());
            this.form.get('date')?.setValue(data?.date.toDate());

            // Setup questions
            let array = this.form.get('questions') as FormArray;
            data?.questions.forEach((q: any) => {
              array.push(new FormGroup({
                question: new FormControl(q.question),
                ans: new FormControl(q.ans, Validators.required),
                remark: new FormControl(q.remark || '', Validators.required)
              }));
            });

            // *** SET SELECTED CENTRE AFTER DATA IS LOADED ***
            this._centres$.pipe(takeUntil(this._destroyed$)).subscribe(centres => {
              const matchedCentre = centres.find(c => c.centreCode === data?.centreCode);

              if (matchedCentre) {
                this.selectedCentre = matchedCentre;

                // Load children for this centre (needed for child dropdown in edit mode)
                const currentDate2 = new Date();
                currentDate2.setDate(currentDate2.getDate() - 60);

                this.childService.getAllotedChildListByCenter(matchedCentre.centreCode)
                  .pipe(takeUntil(this._destroyed$))
                  .subscribe(allottedChildren => {
                    this.mFirestore.collection<FullChild>('ALChild', ref =>
                      ref.where('centreCode', '==', matchedCentre.centreCode)
                    ).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
                      const temp: any[] = [];
                      const childDocs = res.docs.map(x => x.data() as FullChild);

                      childDocs.forEach(doc => {
                        doc.admissionData.forEach((ad, index) => {
                          if (index % 2 !== 0 && ad.dateOfDischarge?.toDate() >= currentDate2) {
                            let obj = {
                              firstName: doc.firstName,
                              lastName: doc.lastName,
                              childCode: doc.childCode,
                              centreCode: doc.centreCode,
                              centreName: doc.centreName
                            };
                            if (!temp.some(x => x.childCode === doc.childCode)) temp.push(obj);
                          }
                        });
                      });

                      temp.sort((a, b) => a.firstName.localeCompare(b.firstName));

                      const allChildren = [
                        ...temp,
                        ...allottedChildren.filter(ac => !temp.some(dc => dc.childCode === ac.childCode))
                      ];

                      allChildren.sort((a, b) =>
                        `${a.firstName} ${a.lastName}`
                          .toLowerCase()
                          .localeCompare(`${b.firstName} ${b.lastName}`.toLowerCase())
                      );

                      this.childData = allChildren;
                      this.filteredChildData = [...allChildren];
                    });
                  });
              }
            });
          });
      }
    });
  }

  ngOnInit(): void {
    this.childSearchControl.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(text => {
      const value = (text || '').toLowerCase();

      this.filteredChildData = this.childData.filter(c =>
        (`${c.firstName} ${c.lastName}`).toLowerCase().includes(value)
      );
    });

  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onChildDropdownOpen() {
    this.filteredChildData = [...this.childData];
  }



  // onCentreSelect(event: MatSelectChange) {
  //   let c = event.value as Centre;
  //
  //   this.form.get('centreName')?.setValue(c.centreName);
  //   this.form.get('centreCode')?.setValue(c.centreCode);
  //
  //   const currentDate2 = new Date();
  //   currentDate2.setDate(currentDate2.getDate() - 60);
  //
  //   this.childService.getAllotedChildListByCenter(c.centreCode).subscribe(allottedChildren => {
  //
  //     this.mFirestore.collection<FullChild>('ALChild', ref =>
  //       ref.where('centreCode', '==', c.centreCode)
  //     ).get().subscribe(res => {
  //
  //       const temp: any[] = [];
  //       const childDocs = res.docs.map(x => x.data() as FullChild);
  //
  //       childDocs.forEach(doc => {
  //         doc.admissionData.forEach((ad, index) => {
  //           if (index % 2 !== 0 && ad.dateOfDischarge.toDate() >= currentDate2) {
  //             let obj = {
  //               firstName: doc.firstName,
  //               lastName: doc.lastName,
  //               childCode: doc.childCode,
  //               centreCode: doc.centreCode,
  //               centreName: doc.centreName
  //             };
  //             if (!temp.some(x => x.childCode === doc.childCode)) temp.push(obj);
  //           }
  //         });
  //       });
  //
  //       temp.sort((a, b) => a.firstName.localeCompare(b.firstName));
  //
  //       const allChildren = [
  //         ...temp,
  //         ...allottedChildren.filter(ac => !temp.some(dc => dc.childCode === ac.childCode))
  //       ];
  //
  //       this.childData = allChildren;
  //       this.filteredChildData = [...allChildren];
  //     });
  //   });
  // }




  onSelect(option: any) {
    this.selectionChange.emit(option); // not {value: option}
  }

  onCentreSelect(c: Centre) {

    if (!c) return;
    this.form.get('centreName')?.setValue(c.centreName);
    this.form.get('centreCode')?.setValue(c.centreCode);

    const currentDate2 = new Date();
    currentDate2.setDate(currentDate2.getDate() - 60);

    this.childService.getAllotedChildListByCenter(c.centreCode).pipe(takeUntil(this._destroyed$)).subscribe(allottedChildren => {

      this.mFirestore.collection<FullChild>('ALChild', ref =>
        ref.where('centreCode', '==', c.centreCode)
      ).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {

        const temp: any[] = [];
        const childDocs = res.docs.map(x => x.data() as FullChild);

        childDocs.forEach(doc => {
          doc.admissionData.forEach((ad, index) => {
            if (index % 2 !== 0 && ad.dateOfDischarge?.toDate() >= currentDate2) {
              let obj = {
                firstName: doc.firstName,
                lastName: doc.lastName,
                childCode: doc.childCode,
                centreCode: doc.centreCode,
                centreName: doc.centreName
              };
              if (!temp.some(x => x.childCode === doc.childCode)) temp.push(obj);
            }
          });
        });

        temp.sort((a, b) => a.firstName.localeCompare(b.firstName));

        const allChildren = [
          ...temp,
          ...allottedChildren.filter(ac => !temp.some(dc => dc.childCode === ac.childCode))
        ];
        // FINAL A → Z SORT (case-insensitive, full name)
        allChildren.sort((a, b) =>
          `${a.firstName} ${a.lastName}`
            .toLowerCase()
            .localeCompare(`${b.firstName} ${b.lastName}`.toLowerCase())
        );

        this.childData = allChildren;
        this.filteredChildData = [...allChildren];
      });
    });
  }

  childSelect($event: MatSelectChange) {
    const child = $event.value as FullChild;
    if (!child) return;

    // Parent Name Logic
    const guardian1Name = child.guardians?.[0]?.firstName || 'NA';
    const guardian2Name = child.guardians?.[1]?.firstName || 'NA';
    const parentsName = guardian2Name
      ? `${guardian1Name} and ${guardian2Name}`
      : guardian1Name;

    // Patch form fields
    this.form.patchValue({
      parentsName: parentsName,
      childName: `${child.firstName} ${child.lastName}`,
      childCode: child.childCode,
      city: child.city,
      unitCode: child.selectUnit,
      dateOfAdmission: (child.dateOfAdmission as any).toDate()
    });

    // Disable fields
    this.form.get('city')?.disable();
    this.form.get('dateOfAdmission')?.disable();
    this.form.get('parentsName')?.disable();
  }



  searchChild($event: MatSelectChange) {

    let child = $event.value as FullChild
    this.form.get('childName')?.setValue(`${child.firstName} ${child.lastName}`)
    this.form.get('childCode')?.setValue(`${child.childCode}`)

  }

//   Submit() {
// this.disableSubmit =true
//     //SAVE
//
//     if(this.form.valid){
//       this.disableSubmit =true
//
//       // if (this.id == null) this.mFirestore.collection(this.env.counsellingFollowUp).add(this.form.value).then(res => {
//       //   console.log("Data submitted Successfully")
//       //   this.mSnackbar.open('Saved Successfully', '', {
//       //     duration: 3000,
//       //     panelClass: 'success'
//       //   })
//       //   let activity = {
//       //     date: new Date().getTime(),
//       //     section: 'Assessment Counseling',
//       //     action: 'Submit',
//       //
//       //     description: `Assessment Counseling Follow up data ${ this.form.get('centreName')},${this.form.get('childCode')},${this.form.get('dateOfAssessment')} by  `,
//       //     currentIp: localStorage.getItem('currentip')!
//       //   }
//       //   this.mLogService.addLog(activity)
//       //   this.mDailogRef.close()
//       // })
//
//       if(this.id!=null) {
//         this.editMode=true;
//
//         this.mFirestore.collection(this.env.counsellingFollowUp).doc(this.id!!).get().subscribe(res => {
//           let data = res.data() as any;
//
//           this.form.get('centreName')?.setValue(data?.centreName);
//           this.form.get('centreCode')?.setValue(data?.centreCode);
//           this.form.get('sessionType')?.setValue(data?.sessionType);
//           this.form.get('childName')?.setValue(data?.childName);
//           this.form.get('childCode')?.setValue(data?.childCode);
//           this.form.get('dateOfAssessment')?.setValue(data?.dateOfAssessment.toDate());
//           this.form.get('date')?.setValue(data?.date.toDate());
//
//           let array = this.form.get('questions') as FormArray;
//           data?.questions.forEach((q: any) => {
//             array.push(new FormGroup({
//               question: new FormControl(q.question),
//               ans: new FormControl(q.ans, Validators.required),
//               remark: new FormControl(q.remark || '', Validators.required)
//             }));
//           });
//
//           // *** SET SELECTED CENTRE AFTER DATA IS LOADED ***
//           this._centres$.subscribe(centres => {
//             this.selectedCentre = centres.find(c => c.centreCode === data?.centreCode) || null;
//           });
//         });
//       }
//
//       //UPDATE
//
//       else if (this.id != null) this.mFirestore.collection(this.env.counsellingFollowUp).doc(this.id).update(this.form.value).then(res => {
//         console.log("Data submitted Successfully")
//         this.mSnackbar.open('Updated Successfully', '', {
//           duration: 3000,
//           panelClass: 'success'
//         })
//         let activity = {
//           date: new Date().getTime(),
//           section: 'Assessment Counseling',
//           action: 'Update',
//
//           description: `Assessment Counseling Follow up data ${ this.form.get('centreName')},${this.form.get('childCode')},${this.form.get('dateOfAssessment')} by  `,
//           currentIp: localStorage.getItem('currentip')!
//         }
//         this.mLogService.addLog(activity)
//         this.mDailogRef.close()
//       })
//     }
// else {
//   this.mSnackbar.open('Please enter all fields','',{duration:3000,
//   panelClass:'error'})
// this.disableSubmit =false
// }
//
//   }


  Submit() {
    this.disableSubmit = true;

    if (this.form.valid) {
      this.disableSubmit = true;

      // SAVE NEW RECORD
      if (this.id == null) {
        this.mFirestore.collection(this.env.counsellingFollowUp)
          .add(this.form.value)
          .then(res => {
            console.log("Data submitted Successfully");
            this.mSnackbar.open('Saved Successfully', '', {
              duration: 3000,
              panelClass: 'success'
            });

            let activity = {
              date: new Date().getTime(),
              section: 'Assessment Counseling',
              action: 'Submit',
              description: `Assessment Counseling Follow up data ${this.form.get('centreName')?.value},${this.form.get('childCode')?.value},${this.form.get('dateOfAssessment')?.value} by  `,
              currentIp: localStorage.getItem('currentip')!
            };
            this.mLogService.addLog(activity);
            this.mDailogRef.close();
          });
      }
      // UPDATE EXISTING RECORD
      else if (this.id != null) {
        this.mFirestore.collection(this.env.counsellingFollowUp)
          .doc(this.id)
          .update(this.form.value)
          .then(res => {
            console.log("Data updated Successfully");
            this.mSnackbar.open('Updated Successfully', '', {
              duration: 3000,
              panelClass: 'success'
            });

            let activity = {
              date: new Date().getTime(),
              section: 'Assessment Counseling',
              action: 'Update',
              description: `Assessment Counseling Follow up data ${this.form.get('centreName')?.value},${this.form.get('childCode')?.value},${this.form.get('dateOfAssessment')?.value} by  `,
              currentIp: localStorage.getItem('currentip')!
            };
            this.mLogService.addLog(activity);
            this.mDailogRef.close();
          });
      }
    } else {
      this.mSnackbar.open('Please enter all fields', '', {
        duration: 3000,
        panelClass: 'error'
      });
      this.disableSubmit = false;
    }
  }



  setupQuestions(questionList: any[]) {
    questionList.forEach(question=>{
      this.formArray.push(new FormGroup({
        question:new FormControl(question.question),
        ans:new FormControl('',Validators.required),
        remark:new FormControl('')
      }))
    })

  }
  get formArray(){
    return this.form.get('questions') as FormArray
  }


}
